import React, { createContext, useContext } from "react";

const MembershipQuitFormContext = createContext(undefined);

export const MembershipQuitFormProvider = ({ children, value }) => {
	return (
		<MembershipQuitFormContext.Provider value={value}>
			{children}
		</MembershipQuitFormContext.Provider>
	);
};

export const useMembershipQuitFormContext = () => {
	const context = useContext(MembershipQuitFormContext);

	if (context === undefined) {
		throw new Error(
			"useMembershipQuitFormContext 必須在 MembershipQuitFormProvider 中使用",
		);
	}

	return context;
};
